import { Shark, Utils, View } from "shark-mvc";
import { Collapse } from "bootstrap";

import Project from "../../models/Project";

import templateContent from "./project-list.html";

import activityListView from "../activity/activityListView";
import mainNavComponent from "../../components/main-nav/mainNavComponent";
import projectManager from "../../controllers/projectManager";
import projectSettingsComponent from "../../components/project-settings/projectSettingsComponent";
import userManager from "../../controllers/userManager";
import waitBoxComponent from "../../components/wait-box/waitBoxComponent";

class ProjectListView extends View {
	constructor () {
		super("projectListView");

		this.setTemplate(templateContent);
		this.$mainRoute = "projects";
	}

	afterLoad () {
		this.collapse = new Collapse(document.querySelector("#newProjectBox"), {
			toggle: false,
		});
	}

	async beforeLoad () {
		Shark.set({
			__pageTitle: "Progetti",
		});

		await userManager.checkUserList();

		const { projectList } = Shark.get();

		if (!projectList || projectList.length === 0) {
			this.refreshList();
		}
	}

	cancelProjectEdits () {
		if (!Shark.$store?.currProject?.isDirty() || confirm("Vuoi annullare?")) {
			Shark.$store.currProject.restore();
			this.collapse?.hide();
		}
	}
	
	cancelProjectEditsBtn_clickHandler () {
		this.cancelProjectEdits();
	}

	closeProject (guid) {
		const project = Utils.safp(Shark.$store.projectList, "guid", guid);

		if (project && confirm("Confermi di voler chiudere questo Progetto?")) {
			projectManager.close(project)
			.then(() => {
				this.refreshList();
			});
		}
	}

	closeProjectBtn_clickHandler (event, data) {
		this.closeProject(data.guid);
	}

	createNewProjectBtn_clickHandler () {
		const currProject = new Project({
			status: 1,
		});

		Shark.set({
			currProject,
		});

		document.querySelector("#projectNameField")?.focus();
	}

	editProject (guid) {
		const currProject = Utils.safp(Shark.$store.projectList, "guid", guid);

		if (currProject) {
			Shark.set({ currProject });
			Shark.render();
			this.collapse.show();
		}
	}

	editProjectBtn_clickHandler (event, data) {
		this.editProject(data.guid);
	}

	init () {
		this.addComponents([mainNavComponent, projectSettingsComponent, waitBoxComponent]);

		let projectViewFiltersData = Utils.parseJSON(localStorage.getItem("projectViewFilters"), "object");
		
		const projectViewFilters = Shark.getInstance("__smart__", {
			showArchivedProjects: projectViewFiltersData ? projectViewFiltersData.showArchivedProjects : true,
			showClosedProjects: projectViewFiltersData ? projectViewFiltersData.showClosedProjects : false,
			showOpenProjects: projectViewFiltersData ? projectViewFiltersData.showOpenProjects : true,
			
			showActiveProjects: projectViewFiltersData ? projectViewFiltersData.showActiveProjects : true,
			showCreatedProjects: projectViewFiltersData ? projectViewFiltersData.showCreatedProjects : true,
		});

		projectViewFilters.onDataChanged = function () {
			localStorage.setItem("projectViewFilters", JSON.stringify(this.export()));
			projectListView.refreshList();
		};

		Shark.set({
			projectList: [],
			projectViewFilters,
			__pageTitle: "Progetti",
		});
	}

	projectBtn_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick")) {
			return;
		}
		const currProject = Utils.safp(Shark.$store.projectList, "guid", data.guid);

		if (currProject) {
			waitBoxComponent.open();
			Shark.set({ currProject });
			Shark.openPage(activityListView, {urlSearchParams: { prjguid: currProject.guid } });
		}
	}

	async refreshList () {
		projectManager.getList(Shark.$store.projectViewFilters)
		.then(response => {
			console.log({response});
			const projectList = Shark.getInstanceList(Project, response.data);

			projectList.forEach((item, index) => {
				item.__index = index;
				item.__displayIndex = index + 1;
				// item.rnd = Math.random();//Alla ricreazione delle list quando riassegno gli __shguid dovrei poi usarli per calcolare l'hash, se no non si accorge del reload... ma è tutto vero davvero?
			});

			Shark.set({
				projectList,
			});
		});
	}

	refresListBtn_clickHandler () {
		this.refreshList();
	}

	reopenProject (guid) {
		const selectedProject = Utils.safp(Shark.$store.projectList, "guid", guid);

		if (selectedProject) {
			projectManager.reOpen(selectedProject)
			.then(response => {
				console.log(response);
				this.refreshList();
			});
		}
	}

	reopenProjectBtn_clickHandler (event, data) {
		this.reopenProject(data.guid);
	}

	saveNewProject () {
		const { currProject } = Shark.get();

		if (currProject) {
			const errorList = currProject.validate();

			if (errorList.length > 0) {
				alert("Si sono verificati i seguenti errori:\n\n" + errorList.join("\n"));
			}
			else {
				projectManager.save(currProject)
				.then(response => {
					console.log(response);
					this.collapse.hide();
					this.refreshList();
				});
			}
		}
	}

	saveNewProjectBtn_clickHandler () {
		this.saveNewProject();
	}

	setProjectSettings (project) {
		projectSettingsComponent.open(project);
	}

	setProjectSettingsBtn_clickHandler (event, data) {
		const { projectList } = Shark.get();
		const currProject = Utils.safp(projectList, "guid", data.guid);

		if (currProject) {
			this.setProjectSettings(currProject);
		}
	}
}

const projectListView = new ProjectListView();

Shark.registerView(projectListView);

export default projectListView;
